(() => {
  'use strict';
  if (window.gdEquipmentInquiryTracking) return;

  const pendingKey = 'gd_equipment_inquiry_pending_v1';
  const measurementId = 'G-6YB77D6J5G';
  const maxAge = 30 * 60 * 1000;
  const selector = '.gd-contact-form, .gd-availability-form';
  const script = document.currentScript;
  const preview = script?.dataset.gdInquiryPreview === 'true' ||
    /^\d+$/.test(new URL(window.location.href).searchParams.get('preview_theme_id') || '');
  let tagReady = false;

  function privacyAllowed() {
    const dnt = String(navigator.doNotTrack || window.doNotTrack || '').toLowerCase();
    if (navigator.globalPrivacyControl === true || dnt === '1' || dnt === 'yes') return false;
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  }

  function clearPending() {
    try { window.sessionStorage.removeItem(pendingKey); } catch {}
  }

  function readPending() {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(pendingKey));
      if (!value || typeof value.id !== 'string' || !/^[a-f0-9-]{32,36}$/.test(value.id) ||
          !Number.isFinite(value.at) || Date.now() - value.at < 0 || Date.now() - value.at > maxAge) {
        clearPending();
        return null;
      }
      return value;
    } catch { return null; }
  }

  function inquiryType(form) {
    return form.querySelector('[name="contact[Inquiry type]"]')?.value || '';
  }

  function setReturnPath(form, context) {
    const input = form.querySelector('[name="return_to"]');
    if (!input) return;
    const current = new URL(window.location.href);
    const target = new URL(current.pathname, current.origin);
    target.searchParams.set('contact_posted', 'true');
    if (context.dataset.gdInquiryContext === 'contact_page') {
      const type = inquiryType(form);
      if (type === 'Equipment sales') target.searchParams.set('inquiry', 'equipment');
      if (type === 'Order support') target.searchParams.set('inquiry', 'order');
      target.hash = form.id;
    } else {
      if (/^\d+$/.test(context.dataset.variantId || '')) target.searchParams.set('variant', context.dataset.variantId);
      target.hash = 'gd-availability';
    }
    if (/^\d+$/.test(current.searchParams.get('preview_theme_id') || '')) {
      target.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
    }
    if (current.searchParams.get('tracking_test') === '1') target.searchParams.set('tracking_test', '1');
    input.value = target.pathname + target.search + target.hash;
  }

  function newId() {
    if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID();
    if (typeof window.crypto?.getRandomValues !== 'function') return '';
    return Array.from(window.crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
  }

  function prepare(form, context) {
    setReturnPath(form, context);
    clearPending();
    if (window.Shopify?.designMode || inquiryType(form) !== 'Equipment sales' || !privacyAllowed()) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    const id = newId();
    if (!id) return;
    const record = {
      id, at: Date.now(), form: form.id, path: window.location.pathname,
      location: context.dataset.gdInquiryContext,
      product: context.dataset.productId || '', variant: context.dataset.variantId || '',
      test: preview || new URL(window.location.href).searchParams.get('tracking_test') === '1'
    };
    try { window.sessionStorage.setItem(pendingKey, JSON.stringify(record)); } catch {}
  }

  function updateTagConsent() {
    if (!tagReady || typeof window.gtag !== 'function') return;
    window.gtag('consent', 'update', {
      analytics_storage: privacyAllowed() ? 'granted' : 'denied',
      ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied'
    });
  }

  function initializeTag(parameters) {
    if (tagReady) return;
    const existingTag = typeof window.gtag === 'function';
    if (!existingTag) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
    }
    tagReady = true;
    updateTagConsent();
    if (!existingTag) window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      page_location: parameters.page_location,
      page_title: 'Equipment inquiry',
      page_referrer: ''
    });
    const loaderPresent = Array.from(document.scripts).some(node => {
      try {
        const url = new URL(node.src);
        return url.hostname === 'www.googletagmanager.com' && url.pathname === '/gtag/js';
      } catch { return false; }
    });
    if (!existingTag && !loaderPresent) {
      const loader = document.createElement('script');
      loader.async = true;
      loader.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
      document.head.appendChild(loader);
    }
  }

  function complete(scope = document) {
    const pending = readPending();
    if (!pending || pending.path !== window.location.pathname) return;
    const form = document.getElementById(pending.form);
    if (!form || !scope.contains(form)) return;
    if (form.querySelector('[data-gd-inquiry-error]')) { clearPending(); return; }
    const success = form.querySelector('[data-gd-inquiry-success]');
    if (!success) return;
    if (window.Shopify?.designMode) { clearPending(); return; }
    if (typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') return;
    if (!privacyAllowed()) { clearPending(); return; }
    const data = { lead_id: pending.id, lead_type: 'equipment',
      form_location: pending.location === 'product' ? 'shop_product_inquiry' : 'shop_contact_equipment',
      page_location: 'https://shop.grodrones.com' + pending.path,
      page_title: 'Equipment inquiry', page_referrer: '', send_to: measurementId };
    if (/^\d+$/.test(pending.product)) data.product_id = pending.product;
    if (/^\d+$/.test(pending.variant)) data.variant_id = pending.variant;
    if (pending.test) data.debug_mode = true;
    clearPending();
    success.focus({ preventScroll: true });
    try {
      const clean = new URL(window.location.href);
      clean.searchParams.delete('contact_posted');
      window.history.replaceState(null, '', clean.pathname + clean.search + clean.hash);
    } catch {}
    try {
      initializeTag(data);
      window.gtag('event', pending.test ? 'lead_tracking_test' : 'generate_lead', data);
    } catch {}
  }

  function init(scope = document) {
    scope.querySelectorAll(selector).forEach(form => {
      const context = form.closest('[data-gd-inquiry-context]');
      if (!context || form.dataset.gdInquiryBound) return;
      form.dataset.gdInquiryBound = 'true';
      setReturnPath(form, context);
      form.addEventListener('submit', () => prepare(form, context));
    });
    complete(scope);
  }

  window.gdEquipmentInquiryTracking = { init };
  init();
  window.addEventListener('load', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('visitorConsentCollected', () => { updateTagConsent(); complete(); });
  if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) complete();
    });
  }
})();
